import { isValidBankAccount } from '@tymbe/bank-account';

const validateBankAccount = (bankAcc: string) => {
  // validation happens only if bank account is filled
  if (!bankAcc || isValidBankAccount(bankAcc)) return undefined;

  return 'Zadejte platný bankovní účet';
};
export default validateBankAccount;
